import { adminGuard, authGuard, publicGuard } from '@/app/core/guards';
import { Routes } from '@angular/router';
import { UnauthorizedComponent } from '@/app/shared/components';

export const routes: Routes = [
    {
        path: '',
        loadChildren: () => import('./features/dashboard/dashboard.routes').then((r) => r.DASHBOARD_ROUTES),
        canActivate: [authGuard],
    },
    {
        path: 'release',
        loadChildren: () => import('./features/release/release.routes').then((r) => r.RELEASE_ROUTES),
        canActivate: [authGuard],
        canMatch: [authGuard],
    },
    {
        path: 'projects',
        loadChildren: () => import('./features/projects/projects.routes').then((r) => r.PROJECTS_ROUTES),
        canActivate: [authGuard],
        canMatch: [authGuard],
    },
    {
        path: 'clients',
        loadChildren: () => import('./features/clients/clients.routes').then((r) => r.CLIENTS_ROUTES),
        canActivate: [authGuard],
        canMatch: [authGuard],
    },
    {
        path: 'mpd',
        loadChildren: () => import('./features/mpd/mpd.routes').then((r) => r.MPD_ROUTES),
        canActivate: [authGuard],
        canMatch: [authGuard],
    },
    {
        path: 'stability',
        loadChildren: () => import('./features/stability/stability.routes').then((r) => r.STABILITY_ROUTES),
        canActivate: [authGuard],
        canMatch: [authGuard],
    },
    {
        path: 'reports',
        loadChildren: () => import('./features/reports/reports.routes').then((r) => r.REPORTS_ROUTES),
        canActivate: [authGuard],
        canMatch: [authGuard],
    },
    {
        path: 'collaboration',
        loadChildren: () => import('./features/collaboration/collaboration.routes').then((r) => r.COLLABORATION_ROUTES),
        canActivate: [authGuard],
        canMatch: [authGuard],
    },
    {
        path: 'compliance',
        loadChildren: () => import('./features/compliance/compliance.routes').then((r) => r.COMPLIANCE_ROUTES),
        canActivate: [authGuard],
        canMatch: [authGuard],
    },
    {
        path: 'auth',
        loadChildren: () => import('./features/auth/auth.routes').then((r) => r.AUTH_ROUTES),
        canActivate: [publicGuard],
    },
    {
        path: 'notifications',
        loadChildren: () => import('./features/notifications/notifications.routes').then((r) => r.NOTIFICATIONS_ROUTES),
        canActivate: [authGuard],
        canMatch: [authGuard],
    },
    {
        path: 'settings',
        loadChildren: () => import('@/app/features/settings/settings.routes').then((r) => r.SETTINGS_ROUTES),
        canActivate: [authGuard],
        canMatch: [authGuard],
    },
    {
        path: 'admin',
        loadChildren: () => import('./features/admin/admin.routes').then((r) => r.ADMIN_ROUTES),
        canActivate: [authGuard, adminGuard],
        canMatch: [authGuard, adminGuard],
    },
    {
        path: 'unauthorized',
        component: UnauthorizedComponent,
        title: 'Access Denied'
    },
    {
        path: '**',
        redirectTo: '/',
    },
];
